module.exports = __webpack_public_path__ + "media/images/logo_mondadori-e60005c26ed55a62cb1db643e35b5e4d.png";